import { as_clnt } from "../configs/clientConfig";

export const baseURL = as_clnt === "10000" ? "/mall/anna" : "/mall/core";
